import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ProjectTypeDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ProjectTypeId: string;
	@IsNotEmpty() ProjectTypeName: string;
	@IsNotEmpty() ProjectCategoryId: string;
}
